<template>
  <div class="personal">

    <!-- 用户信息 -->
    <div class="personal_data">
      <div class="data">
        <van-image round width="60" height="60" fit="cover" :src="userData.portrait" />
        <div class="data_detail">
          <div class="detail_list" @click="toLogin">
            <div class="fs15">{{ userData.nickname }}</div>
            <div class="fs9 m-t5">手机号:{{ userData.telephone }}</div>
          </div>
          <van-icon name="setting-o" size="20" color="#fff" @click="toSetting()" />
        </div>
      </div>
      <div class="data_tag" @click="toSuperMembers()">
        立即加入超级会员，可获得折扣优惠和推广奖励哦~
        <van-icon name="arrow" color="#fff" />
      </div>
    </div>
    <!-- 推荐工具 -->
    <div class="personal_tool">
      <!-- 我的交易 -->
      <div class="personal_deal">
        <van-cell title="我的交易" :border="false" />
        <div class="deal_data">
          <div class="data_number" @click="toOrderList">
            <div>{{ userData.orderInfoCount_1 }}</div>
            <div>待支付</div>
            <!-- <span>特卖1</span> -->
          </div>
          <div class="data_number" @click="toOrderList">
            <div>{{ userData.orderInfoCount_2 }}</div>
            <div>待接单</div>
          </div>
          <div class="data_number" @click="toOrderList">
            <div>{{ userData.orderInfoCount_3 }}</div>
            <div>合同制作</div>
          </div>
          <div class="data_number" @click="toOrderList">
            <div>{{ userData.orderInfoCount_5 }}</div>
            <div>已完成</div>
          </div>
        </div>
      </div>
      <van-grid :center="false" class="personal_menu" :column-num="4" :border="false">
        <van-cell title="推荐工具" :border="false" /> <!-- is-link value="更多" -->
        <van-grid-item icon="/static/images/personal_01.png" @click="showOverlay = true" text="客服中心"></van-grid-item>
        <van-grid-item icon="/static/images/personal_02.png" text="我的合同" @click="toContractManagement()">
        </van-grid-item>
        <van-grid-item icon="/static/images/personal_08.png" text="我的收藏" @click="collectList">
        </van-grid-item>
        <van-grid-item icon="/static/images/personal_03.png" text="领取中心" @click="toCoupon()"></van-grid-item>
        <van-grid-item icon="/static/images/personal_04.png" text="我的优惠券" @click="toGetCouponCenter()"></van-grid-item>
        <van-grid-item icon="/static/images/personal_05.png" text="超级会员" @click="toSuperMembers()"></van-grid-item>
        <van-grid-item icon="/static/images/personal_07.png" text="场地方" @click="toApplicationForSite()"></van-grid-item>
        <van-grid-item icon="/static/images/personal_06.png" @click="toAppointment()" text="我的预约"></van-grid-item>
      </van-grid>

    </div>

    <van-overlay :show="showOverlay" @click="showOverlay = false">
      <div class="wrapper">
        <van-image height="150px" @click.stop width="150px" :src="brokerInfo.qrcode" fit="cover" />
        <p class="text">长按识别二维码添加客服</p>
      </div>
    </van-overlay>

  </div>

</template>
<script>
import { Button, NavBar } from "vant";
import { Grid, GridItem, Cell, CellGroup, Icon, Image, Overlay } from "vant";
export default {
  components: {
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Icon.name]: Icon,
    [Image.name]: Image,
    [Overlay.name]: Overlay,
  },
  data() {
    return {
      userData: {
        nickname: "未登录",
        orderInfoCount_1: 0,
        orderInfoCount_2: 0,
        orderInfoCount_3: 0,
        orderInfoCount_5: 0,
        portrait: "",
        telephone: "",
      },
      showOverlay: false,
      brokerInfo: '',
    };
  },
  created() {
    this.getLoginUserInfo();
    //获取登录用户信息
    this.brokerDetail();
  },
  methods: {

    //跳转场地方-订单管理
    toOrderList() {
      this.$router.push({ path: "/order/index" });
    },

    //跳转账号设置界面 
    toSetting() {
      this.$router.push({ path: "/personal/setting" });
    },

    //跳转优惠券界面
    toCoupon() {
      this.$router.push({ path: "/personal/coupon" });
    },

    //跳转领券中心界面
    toGetCouponCenter() {
      this.$router.push({ path: "/personal/getCouponCenter" });
    },

    //跳转申请成为超级会员界面
    toSuperMembers() {
      this.$router.push({ path: "/personal/superMembers" });
    },

    toAppointment() {
      this.$router.push({ name: "Appointment" });
    },

    //跳转到登录界面
    toLogin() {
      this.$router.push({ path: "/login" });
    },

    //申请成为场地方（判断申请场地状态）
    toApplicationForSite() {
      var that = this;
      that.$api
        .siteSupplierApplyDetailAPI("")
        .then(function (res) {
          var applyStatus = Number(res.data.data.applyStatus);
          if (res.data.code === 200) {
            // 申请状态，1-待审核/2-已完成/3-已拒绝
            if (applyStatus === 1) {
              //跳转提交申请场地成功界面
              that.$router.push({ path: "/personal/materialProgress" });
            } else if (applyStatus === 2) {
              //跳转场地方界面
              that.$router.push({ name: "Place" });
            } else {
              //跳转申请场地界面
              that.$router.push({ path: "/personal/applicationForSite" });
            }
          }
        })
        .catch(function (err) {
          console.log("error", err);
          that.$router.push({ path: "/personal/applicationForSite" });
        });
    },

    //跳转合同管理界面
    toContractManagement() {
      this.$router.push({ path: "/personal/contractManagement" });
    },

    collectList() {
      this.$router.push({ path: "/personal/collectList" });
    },

    //获取登录用户信息
    getLoginUserInfo() {
      let that = this;
      that.$api
        .getLoginUserInfo("")
        .then(function (res) {
          if (res.data.code === 200) {
            that.userData = res.data.data;
            let tel = res.data.data.telephone;
            that.userData.telephone = tel.replace(tel.substring(3, 7), "****");
          }
        })
        .catch(function (err) {
          console.log("error", err);
          that.$router.push({ path: "/login" });
        });
    },

    //获取登录用户信息
    brokerDetail() {
      let that = this;
      that.$api
        .brokerDetailapi("")
        .then(function (res) {
          if (res.data.code === 200) {
            that.brokerInfo = res.data.data
          }
        })
        .catch(function (err) {
          console.log("error", err);
        });
    },

  },
};
</script>
<style lang="less">
.text{
  margin-top: 30px;
  font-size: 16px;
  color: #0cadfc;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.personal {
  background: #f3f3f3;
  height: 100%;

  //用户数据
  .personal_data {
    padding: 40px 15px;
    background: #f7860e;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    padding-bottom: 50px;

    .data {
      display: flex;
      width: 100%;
      justify-content: space-between;

      .data_detail {
        width: 270px;
        display: flex;
        justify-content: space-between;
        color: #fff;

        .detail_list {
          display: flex;
          flex-flow: column; //垂直排列
          margin-top: 10px;

          >span {
            width: 50px;
            border: 1px solid #fff;
            padding: 2px 5px;
            border-radius: 5px;
            font-size: 10px;
            margin-top: 5px;
          }
        }
      }
    }

    .data_tag {
      margin: auto;
      padding: 10px;
      background: #ff6f6f;
      color: #fff;
      font-size: 11px;
      width: 95%;
      border-radius: 4px;
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  // 推荐工具
  .personal_tool {
    background: #f8f8f6;
    height: 350px;
    position: relative;
    display: flex;
    justify-content: center;

    .van-cell__title {
      font-size: 16px;
      font-weight: bold;
    }

    .personal_deal {
      background: #fff;
      position: absolute;
      top: -35px;
      width: 100%;
      border-radius: 10px;
      overflow: hidden;
      width: 90%;

      .deal_data {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;
        padding: 20px;
        padding-top: 10px;

        .data_number {
          display: flex;
          align-items: center;
          font-size: 30px;
          font-weight: bold;
          flex-direction: column;
          position: relative;

          span {
            position: absolute;
            display: block;
            background: #ec595a;
            color: #fff;
            font-size: 12px;
            padding: 5px 10px;
            border-radius: 25px 25px 25px 0px;
            top: -12px;
            right: -37px;
            transform: scale(0.8);
          }

          & div:nth-child(2) {
            font-size: 13px;
            color: #999;
            font-weight: normal;
          }
        }
      }
    }

    .personal_menu {
      background: #fff;
      position: absolute;
      top: 105px;
      width: 90%;
      border-radius: 10px;
      overflow: hidden;

      .van-grid-item__content {
        padding: 10px 0px !important;
      }

      .van-cell__value {
        font-size: 11px;
      }

      .van-cell__right-icon {
        font-size: 15px !important;
      }

      .van-grid-item__content {
        padding: 16px 15px;
        align-items: center;
      }

      .menu_list {
        font-size: 12px;
        margin-left: 10px;
      }
    }

    .van-cell {
      display: flex;
      align-items: center;

      .van-cell__left-icon,
      .van-cell__right-icon {
        height: unset;
        font-size: 18px;
        line-height: unset;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/personal/index.vue